const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const INPUT = "h-10 w-full rounded-lg border bg-[#0B1018] px-3 text-sm text-[#F5F5F5] outline-none transition-[border-color,box-shadow] duration-150 placeholder:text-[#5F6B7D] focus:border-[#C2A462] focus:ring-2 focus:ring-[#C2A462]/20 disabled:cursor-not-allowed disabled:opacity-60";

const opt = (o) => (typeof o === "string" ? { value: o, label: o } : o);
export const isEmpty = (v) => v === undefined || v === null || (typeof v === "string" && !v.trim());

export function validateFields(sections, values) {
  const errors = {};
  sections.flatMap((s) => s.fields).forEach((f) => {
    if (f.type === "static" || (f.show && !f.show(values))) return;
    const v = values[f.key];
    if (f.required && (f.type === "checkbox" ? !v : f.type === "multicheck" ? !(v || []).length : isEmpty(v))) errors[f.key] = `${f.label} is required`;
    else if (!isEmpty(v) && f.type === "email" && !EMAIL.test(String(v).trim())) errors[f.key] = "Enter a valid email address, e.g. name@business.com.au";
    else if (f.validate) { const m = f.validate(v, values); if (m) errors[f.key] = m; }
  });
  return errors;
}

function Control({ f, value, set, error, readOnly }) {
  const id = `bsd-${f.key}`;
  const border = error ? "bsd-input bsd-err" : "bsd-input";
  const common = { id, disabled: readOnly || f.disabled, "aria-invalid": !!error, "aria-describedby": error ? `${id}-err` : f.hint ? `${id}-hint` : undefined, "data-testid": `drawer-field-${f.key}` };
  if (f.type === "static") return <div className="flex h-10 items-center rounded-lg border border-[#2B3442] bg-[#0B1018]/60 px-3 text-sm text-[#C9D1DC]" data-testid={`drawer-field-${f.key}`}>{f.value ?? value ?? "\u2014"}</div>;
  if (f.type === "checkbox")
    return (
      <label htmlFor={id} className="flex cursor-pointer items-start gap-3 rounded-lg border border-[#2B3442] bg-[#0B1018]/60 px-3 py-2.5 text-sm text-[#E4E8EE] transition-colors hover:border-[#3A4557]">
        <input type="checkbox" {...common} checked={!!value} onChange={(e) => set(f.key, e.target.checked)} className="mt-0.5 h-4 w-4 accent-[#C2A462]" />
        <span>{f.label}{f.hint && <span className="mt-0.5 block text-xs text-[#8592A5]">{f.hint}</span>}</span>
      </label>
    );
  if (f.type === "multicheck") {
    const arr = Array.isArray(value) ? value : [];
    const opts = (f.options || []).map(opt);
    if (!opts.length) return <div className="rounded-lg border border-dashed border-[#2B3442] px-3 py-2.5 text-xs text-[#8592A5]" data-testid={`drawer-field-${f.key}`}>{f.empty || "Nothing to choose yet."}</div>;
    return (
      <div className="flex flex-wrap gap-2" data-testid={`drawer-field-${f.key}`} role="group" aria-label={f.label}>
        {opts.map((o) => {
          const on = arr.includes(o.value);
          return <button type="button" key={o.value} disabled={readOnly || f.disabled} aria-pressed={on} onClick={() => set(f.key, on ? arr.filter((x) => x !== o.value) : [...arr, o.value])}
            className={`rounded-full border px-3 py-1.5 text-xs transition-colors ${on ? "border-[#C2A462] bg-[#C2A462]/15 text-[#EBD6A0]" : "border-[#2B3442] text-[#C9D1DC] hover:border-[#3A4557]"}`} data-testid={`drawer-option-${f.key}-${o.value}`}>{o.label}</button>;
        })}
      </div>
    );
  }
  if (f.type === "select")
    return (
      <select {...common} value={value ?? ""} onChange={(e) => set(f.key, e.target.value)} className={`${INPUT} ${border}`}>
        <option value="">{f.placeholder || "Select\u2026"}</option>
        {(f.options || []).map(opt).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    );
  return <input {...common} type={f.type || "text"} value={value ?? ""} placeholder={f.placeholder} autoComplete={f.autoComplete || (f.type === "password" ? "new-password" : "off")} onChange={(e) => set(f.key, e.target.value)} className={`${INPUT} ${border}`} />;
}

export function DrawerField({ f, values, set, error, readOnly }) {
  if (f.show && !f.show(values)) return null;
  return (
    <div className={f.full === false ? "" : "sm:col-span-2"}>
      {f.type !== "checkbox" && <label htmlFor={`bsd-${f.key}`} className="mb-1.5 block text-xs font-medium text-[#B7C0CD]">{f.label}{f.required && <span className="ml-0.5 text-[#C2A462]" aria-hidden>*</span>}</label>}
      <Control f={f} value={values[f.key]} set={set} error={error} readOnly={readOnly} />
      {error ? <p id={`bsd-${f.key}-err`} className="mt-1.5 text-xs text-red-300" role="alert" data-testid={`drawer-error-${f.key}`}>{error}</p>
        : f.hint && f.type !== "checkbox" && <p id={`bsd-${f.key}-hint`} className="mt-1.5 text-xs text-[#8592A5]">{f.hint}</p>}
    </div>
  );
}
